export default __webpack_public_path__ + "static/media/cisco.8b50dd28.png";